// extracted by mini-css-extract-plugin
export default {"calendar":"DatePicker_calendar__YFGI8","InputWrapper":"DatePicker_InputWrapper__75Nuj","input":"DatePicker_input__RoMmN","img":"DatePicker_img__swWx+"};